module.exports = "/_next/static/images/logo-desktop-new-c72ab39cfe663dc778b251b35186c4a2.svg";